<template>
  <div class="container-fluid row-icons-shell">
    <transition name="row-icons-hint">
      <div
        v-if="mobileHintVisible"
        class="row-icons__mobile-hint"
        :class="{ 'is-animating': mobileHintAnimating }"
        aria-live="polite"
      >
        <span class="row-icons__mobile-hint-dot" aria-hidden="true"></span>
        <span>Sélectionnez votre formation</span>
      </div>
    </transition>

    <transition name="row-icons-dash">
      <div
        v-if="mobileDashboardVisible && mobileDashboardItem"
        :key="mobileDashboardKey"
        class="row-icons__mobile-dash"
        aria-live="polite"
      >
        <button
          type="button"
          class="row-icons__mobile-dash-panel"
          :aria-label="`Ouvrir ${mobileDashboardItem.label}`"
          @click="openItem(mobileDashboardItem)"
        >
          <span class="row-icons__mobile-dash-icon" aria-hidden="true">
            <i :class="mobileDashboardItem.icon"></i>
          </span>
          <div class="row-icons__mobile-dash-copy">
            <strong>{{ mobileDashboardItem.dashboardTitle }}</strong>
            <span>{{ mobileDashboardItem.dashboardMeta }}</span>
            <p>{{ mobileDashboardItem.dashboardText }}</p>
          </div>
          <span class="row-icons__mobile-dash-gear" aria-hidden="true">
            {{ mobileDashboardItem.gauge.gear }}
          </span>
        </button>
      </div>
    </transition>

    <section class="row-icons pop" aria-label="Acces rapides formations">
      <button
        type="button"
        class="row-icons__paddle row-icons__paddle--left"
        :class="{ 'row-icons__paddle--hint': mobileHintAnimating }"
        aria-label="Choix precedent"
        @click="cycleSelection(-1)"
      >
        <span class="row-icons__paddle-mark">-</span>
        <span class="row-icons__paddle-text">Shift</span>
      </button>

      <div
        class="row-icons__cluster"
        @mouseleave="clearActive"
        @focusout="handleClusterFocusOut"
      >
        <div class="row-icons__stack row-icons__stack--left">
          <button
            v-for="item in leftItems"
            :key="item.id"
            type="button"
            class="row-icons__card"
            :class="[
              `row-icons__card--${item.tone}`,
              { 'is-active': activeItem === item.id },
            ]"
            :aria-label="item.label"
            @click="openItem(item)"
            @mouseenter="setActive(item.id)"
            @focus="setActive(item.id)"
            @touchstart.passive="setActive(item.id)"
          >
            <span class="row-icons__icon" aria-hidden="true">
              <i :class="item.icon"></i>
            </span>
            <span class="row-icons__label">
              <strong>{{ item.title }}</strong>
              <span>{{ item.subtitle }}</span>
            </span>
          </button>
        </div>

        <button
          type="button"
          class="row-icons__center"
          :class="{ 'is-idle': !hasActiveItem }"
          :style="centerStyle"
          aria-label="Nos formations"
          @click="circleBtn('formations-taxi-vtc')"
          @mouseenter="clearActive"
          @focus="clearActive"
        >
          <span class="row-icons__dial-track" aria-hidden="true"></span>
          <span
            v-for="tick in gaugeTicks"
            :key="tick.id"
            class="row-icons__dial-tick"
            :class="{ 'is-hot': hasActiveItem && tick.hot }"
            :style="{ transform: `translateX(-50%) rotate(${tick.angle}deg)` }"
            aria-hidden="true"
          ></span>
          <span class="row-icons__dial-needle" aria-hidden="true">
            <span class="row-icons__dial-needle-arm"></span>
            <span class="row-icons__dial-cap"></span>
          </span>
          <span class="row-icons__dial-readout" aria-hidden="true">
            <strong>{{ activeGauge.label }}</strong>
            <span>{{ activeGauge.detail }}</span>
          </span>
          <span
            v-if="activeGauge.gear"
            class="row-icons__dial-gear"
            aria-hidden="true"
          >
            {{ activeGauge.gear }}
          </span>
        </button>

        <div class="row-icons__stack row-icons__stack--right">
          <button
            v-for="item in rightItems"
            :key="item.id"
            type="button"
            class="row-icons__card"
            :class="[
              `row-icons__card--${item.tone}`,
              { 'is-active': activeItem === item.id },
            ]"
            :aria-label="item.label"
            @click="openItem(item)"
            @mouseenter="setActive(item.id)"
            @focus="setActive(item.id)"
            @touchstart.passive="setActive(item.id)"
          >
            <span class="row-icons__icon" aria-hidden="true">
              <i :class="item.icon"></i>
            </span>
            <span class="row-icons__label">
              <strong>{{ item.title }}</strong>
              <span>{{ item.subtitle }}</span>
            </span>
          </button>
        </div>
      </div>

      <button
        type="button"
        class="row-icons__paddle row-icons__paddle--right"
        :class="{ 'row-icons__paddle--hint': mobileHintAnimating }"
        aria-label="Choix suivant"
        @click="cycleSelection(1)"
      >
        <span class="row-icons__paddle-mark">+</span>
        <span class="row-icons__paddle-text">Shift</span>
      </button>
    </section>
  </div>
</template>

<script>
export default {
  name: "RowIcons",
  data() {
    return {
      activeIndex: null,
      mobileDashboardVisible: false,
      mobileDashboardKey: 0,
      mobileHintVisible: false,
      mobileHintAnimating: false,
      mobileHintStopTimeout: null,
      mobileHintHideTimeout: null,
      idleGauge: {
        gear: "",
        label: "Institut",
        detail: "taxi",
        angle: 0,
      },
      items: [
        {
          id: "taxi",
          routeKey: "formation-taxi",
          title: "Formation",
          subtitle: "taxi",
          tone: "taxi",
          icon: "fa fa-taxi",
          label: "Formation taxi",
          gauge: {
            gear: "1",
            label: "TAXI",
            detail: "formation",
            angle: -112,
          },
          dashboardTitle: "Formation taxi",
          dashboardMeta: "Jour, soir ou week-end",
          dashboardText:
            "Preparation complete avec theorie, conduite et accompagnement jusqu'a l'examen.",
        },
        {
          id: "cpf",
          routeKey: "formation-taxi",
          title: "Financement",
          subtitle: "CPF",
          tone: "cpf",
          icon: "fa fa-credit-card",
          label: "Financement CPF",
          gauge: {
            gear: "2",
            label: "CPF",
            detail: "financement",
            angle: -46,
          },
          dashboardTitle: "Financement CPF",
          dashboardMeta: "Verification de prise en charge",
          dashboardText:
            "Reperez rapidement les parcours eligibles et clarifiez le financement avant l'inscription.",
        },
        {
          id: "modulable",
          routeKey: "formations-acceleree-vtc-taxi",
          title: "Formation",
          subtitle: "modulable",
          tone: "modulable",
          icon: "fa fa-sliders",
          label: "Formation modulable",
          gauge: {
            gear: "3",
            label: "FLEX",
            detail: "modulable",
            angle: 18,
          },
          dashboardTitle: "Formation modulable",
          dashboardMeta: "Formats acceleres et souples",
          dashboardText:
            "Choisissez un rythme adapte a votre agenda avec des options soir, week-end ou accelere.",
        },
        {
          id: "vtc",
          routeKey: "formation-vtc",
          title: "Formation",
          subtitle: "VTC",
          tone: "vtc",
          icon: "fa fa-car",
          label: "Formation VTC",
          gauge: {
            gear: "4",
            label: "VTC",
            detail: "chauffeur",
            angle: 82,
          },
          dashboardTitle: "Formation VTC",
          dashboardMeta: "Objectif carte professionnelle",
          dashboardText:
            "Visualisez le parcours VTC et les etapes cles pour avancer vers l'activite de chauffeur.",
        },
      ],
    };
  },
  computed: {
    leftItems() {
      return this.items.slice(0, 2);
    },
    rightItems() {
      return this.items.slice(2);
    },
    hasActiveItem() {
      return (
        Number.isInteger(this.activeIndex) &&
        this.activeIndex >= 0 &&
        this.activeIndex < this.items.length
      );
    },
    activeItem() {
      return this.hasActiveItem ? this.items[this.activeIndex].id : null;
    },
    activeGauge() {
      return this.hasActiveItem
        ? this.items[this.activeIndex].gauge
        : this.idleGauge;
    },
    mobileDashboardItem() {
      return this.hasActiveItem ? this.items[this.activeIndex] : null;
    },
    centerStyle() {
      return {
        "--needle-angle": `${this.activeGauge.angle}deg`,
      };
    },
    gaugeTicks() {
      return [
        { id: 1, angle: -118, hot: false },
        { id: 2, angle: -88, hot: false },
        { id: 3, angle: -58, hot: false },
        { id: 4, angle: -28, hot: false },
        { id: 5, angle: 2, hot: false },
        { id: 6, angle: 32, hot: true },
        { id: 7, angle: 62, hot: true },
        { id: 8, angle: 92, hot: true },
      ];
    },
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".pop");
    });

    this.startMobileHint();
  },
  beforeUnmount() {
    this.clearMobileHintTimers();
  },
  methods: {
    circleBtn(itemActif) {
      this.dismissMobileHint();
      this.$router.push({
        path: "/formations-taxi-vtc",
        query: { itemActif: itemActif },
      });
    },
    openItem(item) {
      this.setActive(item.id);
      this.circleBtn(item.routeKey);
    },
    clearActive() {
      this.activeIndex = null;
      this.mobileDashboardVisible = false;
    },
    clearMobileHintTimers() {
      if (this.mobileHintStopTimeout) {
        window.clearTimeout(this.mobileHintStopTimeout);
        this.mobileHintStopTimeout = null;
      }

      if (this.mobileHintHideTimeout) {
        window.clearTimeout(this.mobileHintHideTimeout);
        this.mobileHintHideTimeout = null;
      }
    },
    dismissMobileHint() {
      this.clearMobileHintTimers();
      this.mobileHintAnimating = false;
      this.mobileHintVisible = false;
    },
    setActive(itemId) {
      const index = this.items.findIndex((item) => item.id === itemId);
      if (index !== -1) {
        this.activeIndex = index;
      }
    },
    handleClusterFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.clearActive();
      }
    },
    isCompactViewport() {
      return window.matchMedia("(max-width: 991px)").matches;
    },
    prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    },
    startMobileHint() {
      if (!this.isCompactViewport()) {
        return;
      }

      this.clearMobileHintTimers();
      this.mobileHintVisible = true;

      if (this.prefersReducedMotion()) {
        this.mobileHintHideTimeout = window.setTimeout(() => {
          this.mobileHintVisible = false;
        }, 2600);
        return;
      }

      this.mobileHintAnimating = true;
      this.mobileHintStopTimeout = window.setTimeout(() => {
        this.mobileHintAnimating = false;
      }, 3400);
      this.mobileHintHideTimeout = window.setTimeout(() => {
        this.mobileHintVisible = false;
      }, 4300);
    },
    showMobileDashboard() {
      if (!this.isCompactViewport() || !this.mobileDashboardItem) {
        return;
      }

      this.mobileDashboardKey += 1;
      this.mobileDashboardVisible = true;
    },
    cycleSelection(direction) {
      this.dismissMobileHint();
      const total = this.items.length;
      if (!this.hasActiveItem) {
        this.activeIndex = direction < 0 ? total - 1 : 0;
        this.showMobileDashboard();
        return;
      }
      this.activeIndex = (this.activeIndex + direction + total) % total;
      this.showMobileDashboard();
    },
    anchorBtn(anchor) {
      if (anchor === "nightLesson") {
        this.$router.push({
          path: "/formations-taxi-vtc#nightLesson",
        });
      }
      if (anchor === "formation-gratuite") {
        this.$router.push({
          path: "/formations-taxi-vtc#formation-gratuite",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row-icons-shell {
  position: relative;
  padding: 0 3px;
  overflow: visible;
}

.row-icons__mobile-hint {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  z-index: 19;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: max-content;
  max-width: calc(100% - 12px);
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  border: 1px solid rgba(254, 185, 20, 0.42);
  background: rgba(4, 8, 15, 0.82);
  color: #fff3cf;
  font-family: "adam";
  font-size: 0.54rem;
  letter-spacing: 0.18em;
  line-height: 1;
  text-transform: uppercase;
  text-align: center;
  transform: translateX(-50%);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.24), 0 0 18px rgba(254, 185, 20, 0.12);
  backdrop-filter: blur(8px);
  pointer-events: none;
}

.row-icons__mobile-hint.is-animating {
  animation: row-icons-mobile-hint-blink 0.75s ease-in-out 4;
}

.row-icons__mobile-hint-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #feb914;
  box-shadow: 0 0 0 3px rgba(254, 185, 20, 0.18),
    0 0 12px rgba(254, 185, 20, 0.46);
}

.row-icons-hint-enter-active,
.row-icons-hint-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.row-icons-hint-enter-from,
.row-icons-hint-leave-to {
  opacity: 0;
  transform: translate(-50%, 8px);
}

.row-icons__mobile-dash {
  position: absolute;
  top: auto;
  bottom: calc(100% + 18px);
  left: 50%;
  z-index: 18;
  width: min(calc(100% - 12px), 420px);
  margin: 0;
  transform: translateX(-50%);
  pointer-events: none;
}

.row-icons__mobile-dash-panel {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 13px 15px;
  border: 1px solid rgba(58, 165, 255, 0.24);
  outline: 0;
  border-radius: 20px;
  background: rgba(4, 8, 15, 0.95);
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 0 0 1px rgba(0, 42, 84, 0.24),
    0 0 18px rgba(58, 165, 255, 0.08);
  backdrop-filter: blur(10px);
  appearance: none;
  text-align: left;
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    border-color: rgba(255, 71, 99, 0.36);
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.34),
      inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 0 0 1px rgba(255, 71, 99, 0.28),
      0 0 22px rgba(58, 165, 255, 0.1), 0 0 14px rgba(255, 71, 99, 0.12);
  }

  &::before {
    content: "";
    position: absolute;
    top: 9px;
    left: 15px;
    right: 15px;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(58, 165, 255, 0) 0%,
      rgba(58, 165, 255, 0.72) 24%,
      rgba(255, 71, 99, 0.78) 50%,
      rgba(58, 165, 255, 0.72) 76%,
      rgba(58, 165, 255, 0) 100%
    );
    opacity: 0.75;
  }

  &::after {
    content: "";
    position: absolute;
    right: 15px;
    bottom: 9px;
    width: 72px;
    height: 2px;
    border-radius: 999px;
    background: linear-gradient(
      90deg,
      rgba(255, 71, 99, 0) 0%,
      rgba(255, 71, 99, 0.9) 100%
    );
    box-shadow: 0 0 12px rgba(255, 71, 99, 0.22);
  }
}

.row-icons__mobile-dash-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 23, 43, 0.98);
  color: #55b7ff;
  font-size: 1.2rem;
  box-shadow: inset 0 0 0 1px rgba(58, 165, 255, 0.22),
    0 0 16px rgba(58, 165, 255, 0.14);
}

.row-icons__mobile-dash-copy {
  min-width: 0;

  strong {
    display: block;
    font-family: "quantum";
    font-size: 0.88rem;
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #64bdff;
    text-shadow: 0 0 14px rgba(58, 165, 255, 0.28);
  }

  span {
    display: block;
    margin-top: 0.2rem;
    font-family: "quantum";
    font-size: 0.56rem;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: #ff5f73;
    text-shadow: 0 0 10px rgba(255, 71, 99, 0.22);
  }

  p {
    margin: 0.42rem 0 0;
    font-family: "adam";
    font-size: 0.57rem;
    line-height: 1.5;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(163, 212, 255, 0.84);
    text-shadow: 0 0 10px rgba(58, 165, 255, 0.08);
  }
}

.row-icons__mobile-dash-gear {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 71, 99, 0.12);
  color: #ff6279;
  font-family: "quantum";
  font-size: 0.82rem;
  letter-spacing: 0.16em;
  line-height: 1;
  text-shadow: 0 0 12px rgba(255, 71, 99, 0.28);
  box-shadow: inset 0 0 0 1px rgba(255, 71, 99, 0.24),
    0 0 14px rgba(255, 71, 99, 0.1);
}

.row-icons-dash-enter-active,
.row-icons-dash-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.row-icons-dash-enter-from,
.row-icons-dash-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}

.row-icons {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 0;
  width: min(100%, 420px);
  margin: 18px auto 12px;
  padding: 0 0 18px;
}

.row-icons__cluster {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  min-height: 172px;
  overflow: visible;
}

.row-icons__stack {
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 0;
  min-width: 0;

  &--left {
    border-right: 1px solid rgba(255, 255, 255, 0.12);
  }

  .row-icons__card:first-child {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
}

.row-icons__card {
  --card-active-background: linear-gradient(145deg, #2b3138 0%, #12171d 100%);
  --card-active-color: #f7fafc;
  --card-active-icon: currentColor;
  --card-active-ring: rgba(255, 255, 255, 0.34);
  position: relative;
  z-index: 1;
  border: none;
  min-height: 84px;
  padding: 0.72rem 0.45rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  text-align: center;
  border-radius: 0;
  background: rgba(12, 16, 21, 0.48);
  color: rgba(218, 225, 233, 0.56);
  opacity: 1;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease,
    background-color 0.2s ease, background-image 0.2s ease, color 0.2s ease;
  box-shadow: none;
  cursor: pointer;

  &:hover {
    background: var(--card-active-background);
    color: var(--card-active-color);
    opacity: 1;
  }

  &:focus-visible {
    background: var(--card-active-background);
    color: var(--card-active-color);
    opacity: 1;
    outline: 1px solid var(--card-active-ring);
    outline-offset: -1px;
  }

  &.is-active {
    z-index: 2;
    background: var(--card-active-background);
    color: var(--card-active-color);
    opacity: 1;
    box-shadow: inset 0 0 0 1px var(--card-active-ring);
  }
}

.row-icons__stack--left .row-icons__card {
  align-items: flex-start;
  padding-right: 3.15rem;
}

.row-icons__stack--right .row-icons__card {
  align-items: flex-end;
  padding-left: 3.15rem;
}

.row-icons__stack--left .row-icons__card:first-child {
  border-top-left-radius: 0;
}

.row-icons__stack--left .row-icons__card:last-child {
  border-bottom-left-radius: 0;
}

.row-icons__stack--right .row-icons__card:first-child {
  border-top-right-radius: 0;
}

.row-icons__stack--right .row-icons__card:last-child {
  border-bottom-right-radius: 0;
}

.row-icons__card--taxi {
  --card-active-background: #030507;
  --card-active-color: #f7fafc;
  --card-active-icon: #f7fafc;
  --card-active-ring: rgba(255, 255, 255, 0.28);
}

.row-icons__card--vtc {
  --card-active-background: #030507;
  --card-active-color: #f7fafc;
  --card-active-icon: #f7fafc;
  --card-active-ring: rgba(255, 255, 255, 0.28);
}

.row-icons__card--cpf {
  --card-active-background: linear-gradient(145deg, #0a386b 0%, #002a54 100%);
  --card-active-color: #f7fafc;
  --card-active-icon: #feb914;
}

.row-icons__card--modulable {
  --card-active-background: linear-gradient(145deg, #ffcb43 0%, #feb914 100%);
  --card-active-color: #f7fafc;
  --card-active-icon: #002a54;
}

.row-icons__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  min-height: 42px;
  font-size: 1.45rem;
  line-height: 1;
  color: rgba(210, 218, 227, 0.5);
}

.row-icons__card:hover .row-icons__icon,
.row-icons__card:focus-visible .row-icons__icon,
.row-icons__card.is-active .row-icons__icon {
  color: var(--card-active-icon);
}

.row-icons__label {
  display: none;
}

.row-icons__center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 4;
  transform: translate(-50%, -50%);
  width: 104px;
  height: 104px;
  border: 4px solid transparent;
  border-radius: 50%;
  background: radial-gradient(
    circle at 32% 28%,
    #4d5560 0%,
    #181e26 45%,
    #04070b 100%
  );
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.34),
    inset 0 5px 10px rgba(255, 255, 255, 0.12),
    inset 0 -6px 12px rgba(0, 0, 0, 0.42);
  display: flex;
  justify-content: center;
  align-items: center;
  background-clip: padding-box;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;

  &:hover {
    transform: translate(-50%, -50%) scale(1.03);
  }

  &:focus-visible {
    outline: 3px solid rgba(255, 255, 255, 0.78);
    outline-offset: 2px;
  }
}

.row-icons__center.is-idle .row-icons__dial-needle-arm {
  opacity: 0.58;
  box-shadow: none;
}

.row-icons__dial-track {
  position: absolute;
  inset: 10px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-bottom-color: transparent;
  background: radial-gradient(
    circle at 50% 62%,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.02) 58%,
    rgba(0, 0, 0, 0.32) 100%
  );
}

.row-icons__dial-tick {
  position: absolute;
  left: 50%;
  top: 10px;
  width: 2px;
  height: 11px;
  border-radius: 999px;
  background: rgba(255, 248, 234, 0.4);
  transform-origin: center 39px;

  &.is-hot {
    background: rgba(185, 18, 18, 0.95);
  }
}

.row-icons__dial-needle {
  position: absolute;
  inset: 0;
  transform: rotate(var(--needle-angle, -112deg));
  transition: transform 0.52s cubic-bezier(0.22, 1, 0.36, 1);
}

.row-icons__dial-needle-arm {
  position: absolute;
  left: 50%;
  top: 15px;
  width: 3px;
  height: 35px;
  border-radius: 999px;
  background: linear-gradient(180deg, #ff4036 0%, #7b0909 100%);
  transform: translateX(-50%);
  transform-origin: center bottom;
  box-shadow: 0 0 10px rgba(192, 14, 14, 0.18);
}

.row-icons__dial-cap {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid rgba(255, 248, 234, 0.95);
  background: linear-gradient(180deg, #002a54 0%, #021a31 100%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.24);
}

.row-icons__dial-readout {
  position: absolute;
  bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;

  strong {
    font-family: "cunia";
    font-size: 0.72rem;
    font-weight: normal;
    letter-spacing: 0.08em;
    color: #feb914;
  }

  span {
    margin-top: 0.14rem;
    font-family: "adam";
    font-size: 0.34rem;
    letter-spacing: 0.18em;
    color: #c63d34;
  }
}

.row-icons__dial-gear {
  position: absolute;
  top: 17px;
  right: 17px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 248, 234, 0.12);
  color: $color-text-light;
  font-family: "cunia";
  font-size: 0.5rem;
  line-height: 1;
}

.row-icons__paddle {
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: clamp(52px, 14vw, 60px);
  min-height: 172px;
  padding: 0.55rem 0.3rem;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: linear-gradient(
    180deg,
    #7b8188 0%,
    #424952 10%,
    #181d24 28%,
    #05070a 100%
  );
  color: $color-text-light;
  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.26),
    inset 0 1px 0 rgba(255, 255, 255, 0.16),
    inset 0 -1px 0 rgba(255, 255, 255, 0.04);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(255, 255, 255, 0.28);
    box-shadow: 0 22px 34px rgba(0, 0, 0, 0.32),
      inset 0 1px 0 rgba(255, 255, 255, 0.18),
      inset 0 -1px 0 rgba(255, 255, 255, 0.05);
  }

  &:focus-visible {
    outline: 3px solid rgba(254, 185, 20, 0.8);
    outline-offset: 4px;
  }
}

.row-icons__paddle--hint {
  border-color: rgba(254, 185, 20, 0.52);
  box-shadow: 0 20px 34px rgba(0, 0, 0, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    inset 0 -1px 0 rgba(255, 255, 255, 0.05), 0 0 0 1px rgba(254, 185, 20, 0.18),
    0 0 18px rgba(254, 185, 20, 0.16);
  animation: row-icons-paddle-glow 0.85s ease-in-out 4;

  &::after {
    content: "";
    position: absolute;
    top: -18%;
    bottom: -18%;
    left: -85%;
    width: 58%;
    transform: skewX(-18deg);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.12) 18%,
      rgba(254, 185, 20, 0.78) 50%,
      rgba(255, 255, 255, 0.12) 82%,
      rgba(255, 255, 255, 0) 100%
    );
    box-shadow: 0 0 12px rgba(254, 185, 20, 0.24);
    animation: row-icons-paddle-sheen 0.85s ease-in-out 4;
    pointer-events: none;
  }
}

.row-icons__paddle--hint .row-icons__paddle-mark {
  animation: row-icons-paddle-mark-pulse 0.85s ease-in-out 4;
}

.row-icons__paddle-mark {
  display: block;
  font-family: "Spartan", "Arial Black", Arial, sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 1;
}

.row-icons__paddle-text {
  display: none;
}

.row-icons__paddle--left {
  border-radius: 18px 0 0 18px;
}

.row-icons__paddle--right {
  border-radius: 0 18px 18px 0;
}

@keyframes row-icons-mobile-hint-blink {
  0%,
  100% {
    opacity: 1;
    transform: translateX(-50%);
  }

  50% {
    opacity: 0.38;
    transform: translateX(-50%);
  }
}

@keyframes row-icons-paddle-glow {
  0%,
  100% {
    border-color: rgba(254, 185, 20, 0.38);
    box-shadow: 0 18px 30px rgba(0, 0, 0, 0.26),
      inset 0 1px 0 rgba(255, 255, 255, 0.16),
      inset 0 -1px 0 rgba(255, 255, 255, 0.04),
      0 0 0 1px rgba(254, 185, 20, 0.08), 0 0 8px rgba(254, 185, 20, 0.08);
  }

  50% {
    border-color: rgba(254, 185, 20, 0.56);
    box-shadow: 0 18px 30px rgba(0, 0, 0, 0.26),
      inset 0 1px 0 rgba(255, 255, 255, 0.18),
      inset 0 -1px 0 rgba(255, 255, 255, 0.05),
      0 0 0 1px rgba(254, 185, 20, 0.22), 0 0 18px rgba(254, 185, 20, 0.18);
  }
}

@keyframes row-icons-paddle-sheen {
  0% {
    transform: translateX(0) skewX(-18deg);
    opacity: 0;
  }

  16% {
    opacity: 0.95;
  }

  70% {
    opacity: 0.7;
  }

  100% {
    transform: translateX(320%) skewX(-18deg);
    opacity: 0;
  }
}

@keyframes row-icons-paddle-mark-pulse {
  0%,
  100% {
    text-shadow: none;
  }

  50% {
    text-shadow: 0 0 10px rgba(254, 185, 20, 0.6);
  }
}

@media screen and (min-width: 992px) {
  .row-icons__mobile-hint {
    display: none;
  }

  .row-icons__mobile-dash {
    display: none;
  }

  .row-icons {
    --desktop-card-height: 152px;
    --desktop-paddle-width: clamp(78px, 6vw, 108px);
    gap: 6px;
    width: min(100%, 1420px);
    margin: 20px auto 16px;
    padding-inline: 18px;
    padding-bottom: 14px;
  }

  .row-icons__cluster {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    min-height: 0;
    gap: 0;
  }

  .row-icons__stack {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    gap: 0;
  }

  .row-icons__stack--left {
    border-right: none;
  }

  .row-icons__stack .row-icons__card:first-child {
    border-bottom: none;
  }

  .row-icons__card {
    flex: 1 1 0;
    min-height: var(--desktop-card-height);
    height: var(--desktop-card-height);
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.72rem 1rem;
    gap: 0.72rem;
    border-radius: 0;
    box-shadow: none;

    &.is-active {
      box-shadow: inset 0 0 0 1px var(--card-active-ring);
    }
  }

  .row-icons__stack--left .row-icons__card,
  .row-icons__stack--right .row-icons__card {
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .row-icons__icon {
    min-width: 44px;
    min-height: 44px;
    font-size: 1.7rem;
    flex: 0 0 44px;
  }

  .row-icons__label {
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
    align-items: flex-start;
    text-align: left;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    line-height: 1.02;

    strong {
      font-weight: 700;
      font-size: 0.9rem;
    }

    span {
      font-size: 0.84rem;
    }
  }

  .row-icons__card--cpf {
    padding-right: 4.2rem;
    justify-content: flex-start;
    text-align: left;
  }

  .row-icons__card--modulable {
    padding-left: 4.2rem;
    flex-direction: row-reverse;
    justify-content: flex-start;
    text-align: right;
  }

  .row-icons__card--vtc {
    flex-direction: row-reverse;
  }

  .row-icons__card--modulable .row-icons__label,
  .row-icons__card--vtc .row-icons__label {
    align-items: flex-end;
    text-align: right;
  }

  .row-icons__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 128px;
    height: 128px;
    border-width: 3px;
    box-shadow: 0 15px 22px rgba(0, 0, 0, 0.3),
      inset 0 5px 10px rgba(255, 255, 255, 0.12),
      inset 0 -6px 12px rgba(0, 0, 0, 0.42);

    &:hover {
      transform: translate(-50%, -50%) scale(1.03);
    }
  }

  .row-icons__dial-track {
    inset: 12px;
  }

  .row-icons__dial-tick {
    top: 11px;
    height: 14px;
    transform-origin: center 49px;
  }

  .row-icons__dial-needle-arm {
    top: 17px;
    height: 45px;
  }

  .row-icons__dial-readout {
    bottom: 22px;

    strong {
      font-size: 0.94rem;
    }

    span {
      font-size: 0.4rem;
    }
  }

  .row-icons__dial-gear {
    top: 22px;
    right: 22px;
  }

  .row-icons__paddle {
    width: var(--desktop-paddle-width);
    min-height: var(--desktop-card-height);
    height: var(--desktop-card-height);
    padding: 0.72rem 0.5rem;
  }

  .row-icons__paddle-mark {
    font-size: 1.45rem;
  }

  .row-icons__paddle-text {
    display: block;
    margin-top: 0.12rem;
    font-family: "adam";
    font-size: 0.62rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  .row-icons__paddle--left {
    border-radius: 30px 0 0 30px;
  }

  .row-icons__paddle--right {
    border-radius: 0 30px 30px 0;
  }
}

.pop.active {
  @include fade-in(1.2s);
}
</style>
